<template>
  <div class="landing-container">
    <!-- NAVBAR -->
    <header class="navbar">
      <div class="logo">
        <h2>GAFWA Welfare System</h2>
      </div>

      <div class="nav-buttons">
        <button class="btn btn-outline" @click="goToLogin">
          Admin Login
        </button>

        <button class="btn btn-primary" @click="goToRegister">
          Member Registration
        </button>
      </div>
    </header>

    <!-- HERO SECTION -->
    <section class="hero">
      <div class="hero-content">
        <h1>
          Gusii Advocates First Welfare Association
        </h1>

         <h4>
          To be a member, send ksh 30 to Raise trail paybill 4005097, account your phone number - This is just test
        </h4>

        <p>
          A secure and transparent welfare management platform designed to
          support, connect, and empower over 1000+ members through efficient
          contributions, benefits, and communication.
        </p>

        <div class="hero-actions">
          <button class="btn btn-primary large" @click="goToRegister">
            Join the Welfare
          </button>

          <button class="btn btn-outline large" @click="goToLogin">
            Admin Portal
          </button>
        </div>
      </div>

      <div class="hero-card">
        <h3>Welfare Overview</h3>

        <div class="stat">
          <span class="number">1000+</span>
          <span class="label">Active Members</span>
        </div>

        <div class="stat">
          <span class="number">Secure</span>
          <span class="label">Contribution Tracking</span>
        </div>

        <div class="stat">
          <span class="number">24/7</span>
          <span class="label">System Access</span>
        </div>
      </div>
    </section>

    <!-- FEATURES -->
    <section class="features">
      <h2>System Features</h2>

      <div class="feature-grid">

        <div class="feature-card">
          <h3>Member Management</h3>
          <p>
            Register, manage, and monitor welfare members efficiently.
          </p>
        </div>

        <div class="feature-card">
          <h3>Contribution Tracking</h3>
          <p>
            Record and track welfare contributions transparently.
          </p>
        </div>

        <div class="feature-card">
          <h3>Benefits Management</h3>
          <p>
            Manage claims, benefits, and welfare support easily.
          </p>
        </div>

        <div class="feature-card">
          <h3>Secure Admin Portal</h3>
          <p>
            Admin dashboard with secure authentication and controls.
          </p>
        </div>

      </div>
    </section>

    <!-- FOOTER -->
    <footer class="footer">
      <p>
        © {{ year }} Gusii Advocates First Welfare Association (GAFWA)
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: "LandingPage",

  data() {
    return {
      year: new Date().getFullYear()
    }
  },

  methods: {
    goToLogin() {
      this.$router.push("/login")
    },

    goToRegister() {
      this.$router.push("/member/registration")
    }
  }
}
</script>

<style scoped>
.landing-container {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  color: #1a1a1a;
}

/* NAVBAR */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 40px;
  background: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.logo h2 {
  color: #0a6b3d;
}

.nav-buttons {
  display: flex;
  gap: 12px;
}

/* HERO */
.hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 80px 40px;
  background: linear-gradient(135deg, #0a6b3d, #1fa463);
  color: white;
  flex-wrap: wrap;
}

.hero-content {
  max-width: 600px;
}

.hero-content h1 {
  font-size: 36px;
  margin-bottom: 20px;
}
.hero-content h4 {
  color: #e48686;
}

.hero-content p {
  font-size: 18px;
  margin-bottom: 25px;
}

.hero-actions {
  display: flex;
  gap: 15px;
}

/* HERO CARD */
.hero-card {
  background: white;
  color: #333;
  padding: 25px;
  border-radius: 12px;
  width: 260px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

.stat {
  margin-top: 15px;
}

.number {
  display: block;
  font-size: 24px;
  font-weight: bold;
  color: #0a6b3d;
}

.label {
  font-size: 14px;
}

/* FEATURES */
.features {
  padding: 60px 40px;
  text-align: center;
  background: #f7f9fa;
}

.feature-grid {
  margin-top: 30px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
}

.feature-card {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

/* BUTTONS */
.btn {
  padding: 10px 18px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 600;
}

.large {
  padding: 14px 24px;
}

.btn-primary {
  background: #0a6b3d;
  color: white;
}

.btn-primary:hover {
  background: #085c34;
}

.btn-outline {
  background: transparent;
  border: 2px solid white;
  color: white;
}

.navbar .btn-outline {
  border-color: #0a6b3d;
  color: #0a6b3d;
}

.navbar .btn-outline:hover {
  background: #0a6b3d;
  color: white;
}

/* FOOTER */
.footer {
  text-align: center;
  padding: 20px;
  background: #0a6b3d;
  color: white;
}

/* RESPONSIVE */
@media (max-width: 768px) {

  .hero {
    flex-direction: column;
    gap: 30px;
  }

  .navbar {
    flex-direction: column;
    gap: 10px;
  }
}
</style>